var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnlLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3873A8",
    d: "M16.7,20c-4.5,0-9,0-13.5,0c0,0,0,0,0,0c-0.3,0-0.5-0.1-0.8-0.1c-1-0.3-1.7-1-2.2-2C0.1,17.5,0,17.2,0,16.8 c0,0,0-0.1,0-0.1c0-4.4,0-8.9,0-13.3c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0.1-0.4c0.2-1,0.7-1.7,1.6-2.3c0.5-0.3,1-0.5,1.5-0.5 c0.1,0,0.1,0,0.2,0c4.4,0,8.9,0,13.3,0c0,0,0,0,0.1,0c0.2,0,0.5,0.1,0.7,0.1c1.2,0.3,2.1,1.3,2.4,2.5C20,2.8,20,3,20,3.2 c0,0,0,0,0,0c0,4.5,0,9,0,13.5c0,0,0,0,0,0.1c0,0.1,0,0.3-0.1,0.4c-0.2,0.9-0.6,1.6-1.4,2.1c-0.5,0.4-1.1,0.6-1.7,0.7 C16.8,20,16.8,20,16.7,20z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "14.1,16.9 14.1,3 17,3 17,16.9 14.1,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "10.4,16.9 10.4,5.8 13.3,5.8 13.3,16.9 10.4,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "6.7,16.9 6.7,8.7 9.6,8.7 9.6,16.9 6.7,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "3,11.3 6,11.4 6,16.9 3,16.9 3,11.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnlLogoBlue);
export default __webpack_public_path__ + "static/media/bnl-logo-blue.44d13cc4b458101ca07b9a812049943c.svg";
export { ForwardRef as ReactComponent };